module.exports = __webpack_public_path__ + "static/media/frames-18.edf2d271.jpg";